import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import routes from './routes'

Vue.use(Router)

const index = new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

index.beforeEach((to, from, next) => {
  if ((to.matched.some(record => record.meta.auth)) && (store.state.token == null)) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  if ((to.path === '/login') && (store.state.token !== null)) {
    return next({
      path: '/'
    })
  }
  next()
})

export default index



// WEBPACK FOOTER //
// ./src/router/index.js